import { Checkbox } from "antd"
import { ErrorAlert } from "components/atoms/Alert"
import { Button, LinkButton } from "components/atoms/Button"
import { PageTitle } from "components/atoms/PageTitle"
import {
  AuthForm,
  AuthFormItem,
  FormEmailInput,
  FormPasswordInput,
} from "components/atoms/form"
import { useAsyncLoading } from "hooks/useLoading"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import {
  signUpWithEmailAndPassword,
  sendEmailToVerify,
  firebaseError,
} from "usecases/firebase/auth"

import { useReloadFirebaseAuth } from "../../hooks/useFirebaseAuth"

import type { CheckboxChangeEvent } from "antd/lib/checkbox"
import type { RegisterFormIF } from "interfaces/RegisterFormIF"

const StyledButton = styled(Button)`
  min-width: 6rem;
`

const StyledTerms = styled.div`
  padding-bottom: 1rem;
`

export const RegisterPage = (): JSX.Element => {
  const navigate = useNavigate()
  const [isAccepted, setIsAccepted] = useState(false)
  const [error, setError] = useState("")
  const [loading, asyncLoading] = useAsyncLoading()
  const reloadUser = useReloadFirebaseAuth()

  const onFinish = (values: unknown) => {
    if (!isAccepted) {
      setError("利用規約をご確認のうえで同意をお願いいたします。")
      return
    } else {
      setError("")
    }
    asyncLoading(
      signUpWithEmailAndPassword(
        (values as RegisterFormIF).email,
        (values as RegisterFormIF).password,
      )
        .then(async (useCred) => {
          console.log(useCred)
          if (!useCred) return

          await Promise.all([sendEmailToVerify(), reloadUser()])
          navigate("/register/mail")
        })
        .catch((e) => {
          const code = firebaseError(e.code, "signup")
          code && setError(code)
        }),
    )
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo)
  }
  const onChecked = (e: CheckboxChangeEvent) => {
    setIsAccepted(e.target.checked)
  }

  return (
    <AuthForm onFinish={onFinish} onFinishFailed={onFinishFailed}>
      <PageTitle>
        求人広告掲載企業様向け
        <br /> 新規登録
      </PageTitle>
      <FormEmailInput />
      <FormPasswordInput />
      <StyledTerms>
        <Checkbox value={isAccepted} onChange={onChecked}>
          <a
            href="https://app-qjin-net.web.app/terms/"
            target="_blank"
            rel="noreferrer"
          >
            利用規約
          </a>
          に同意する
        </Checkbox>
      </StyledTerms>

      <AuthFormItem>
        <StyledButton
          isLoading={loading}
          className={"primary"}
          htmlType="submit"
        >
          新規登録
        </StyledButton>
      </AuthFormItem>
      {error && <ErrorAlert>{error}</ErrorAlert>}
      <AuthFormItem>
        <LinkButton to="/">トップへ戻る</LinkButton>
      </AuthFormItem>
    </AuthForm>
  )
}
